/* --------------------------------------------------------------------------------------
   browser.module.js
   Copyright © 2019 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/
import { browserComponent } from "./components/browser.component";
import { browserTableComponent } from "./components/browserTable.component";
import { dynamicGlyphComponent } from "./components/dynamicGlyph.component";
import { folderChangeAlertComponent } from "./components/folderChangeAlert.component";
import { previewComponent } from "./components/preview.component";
import { searchPopupComponent } from "./components/searchPopup.component";
import { clientSearchPopupComponent } from "./components/clientSearchPopup.component";
import { matterSearchPopupComponent } from "./components/matterSearchPopup.component";
import { browserService } from "./services/browser.service";

export const appBrowserModule = angular
  .module("app.browser", [])
  .component("browser", browserComponent)
  .component("browserTable", browserTableComponent)
  .component("dynamicGlyph", dynamicGlyphComponent)
  .component("folderChangeAlert", folderChangeAlertComponent)
  .component("preview", previewComponent)
  .component("searchPopup", searchPopupComponent)
  .component("clientSearchPopup", clientSearchPopupComponent)
  .component("matterSearchPopup", matterSearchPopupComponent)
  .service("browserService", browserService);



// WEBPACK FOOTER //
// ./src/app/browser/browser.module.js